export const timelineEvents = [
  { label: "Intro", time: 0 },
  { label: "Scene 1", time: 5 },
  { label: "Scene 2", time: 12 },
  { label: "Scene 3", time: 20 },
  { label: "Finale", time: 30 }
];